<!-- Overlay -->
<div
  class="fixed inset-0 z-modal bg-black/50 flex items-center justify-center p-4"
  (click)="onOverlayClick()"
>
  <!-- Panel — stop propagation so clicks inside don't close -->
  <div
    class="relative bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-2xl flex flex-col max-h-[90vh]"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
      <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
        Gestionar categorías
      </h2>
      <button
        type="button"
        (click)="cerrar()"
        class="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-gray-800 transition-colors"
        title="Cerrar"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Toolbar -->
    <div class="flex items-center gap-3 px-6 py-3 border-b border-gray-100 dark:border-gray-800 flex-shrink-0">
      <input
        type="text"
        [(ngModel)]="filtroSearch"
        (ngModelChange)="buscar()"
        placeholder="Buscar por nombre o descripción..."
        class="flex-1 px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500/20 focus:border-brand-300"
      />
      <app-button variant="primary" (btnClick)="nuevo()">+ Nueva categoría</app-button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 py-4">
      @if (error) {
        <p class="mb-3 text-sm text-error-600 dark:text-error-400">{{ error }}</p>
      }

      @if (loading) {
        <div class="flex justify-center py-10">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
        </div>
      } @else if (paginated.length === 0) {
        <p class="py-10 text-center text-sm text-gray-500 dark:text-gray-400">
          No hay categorías registradas.
        </p>
      } @else {
        <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
          <table class="min-w-full text-sm">
            <thead class="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Nombre</th>
                <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Descripción</th>
                <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400 w-24">Acciones</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
              @for (c of paginated; track trackById($index, c)) {
                <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
                  <td class="px-3 py-2 font-medium text-gray-900 dark:text-white">{{ c.name }}</td>
                  <td class="px-3 py-2 text-gray-600 dark:text-gray-400 truncate max-w-xs">
                    {{ c.description || '—' }}
                  </td>
                  <td class="px-3 py-2">
                    <div class="flex items-center justify-end gap-1">
                      <button
                        type="button"
                        (click)="editar(c)"
                        title="Editar"
                        class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700"
                      >
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                        </svg>
                      </button>
                      <button
                        type="button"
                        (click)="eliminar(c)"
                        title="Eliminar"
                        class="p-1.5 rounded-lg text-gray-500 hover:bg-error-50 hover:text-error-600 dark:text-gray-400 dark:hover:bg-error-500/10"
                      >
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        @if (globalTotalElements > 5) {
          <div class="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
              <span>Mostrar</span>
              <select
                [(ngModel)]="pageSize"
                (ngModelChange)="onPageSizeChange()"
                class="px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
              >
                @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                  <option [value]="opt">{{ opt }}</option>
                }
              </select>
              <span>de {{ globalTotalElements }} categorías</span>
            </div>
            <div class="flex items-center gap-1">
              <button
                type="button"
                (click)="goToPage(globalPage - 1)"
                [disabled]="globalPage === 0"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                Anterior
              </button>
              <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-400">
                Página {{ globalPage + 1 }} de {{ globalTotalPages || 1 }}
              </span>
              <button
                type="button"
                (click)="goToPage(globalPage + 1)"
                [disabled]="globalPage + 1 >= globalTotalPages"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                Siguiente
              </button>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
